import type { Icon } from '@phosphor-icons/react';

interface EmptyStateProps {
  icon: Icon;
  iconClassName?: string;
  title: string;
  description?: string;
  actions?: React.ReactNode;
}

export function EmptyState({ icon: IconComponent, iconClassName, title, description, actions }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-24 gap-5">
      <div className="flex size-14 items-center justify-center rounded-2xl bg-surface-2 border border-line">
        <IconComponent size={24} weight="duotone" className={iconClassName ?? 'text-fg-muted'} />
      </div>
      <div className="flex flex-col items-center gap-1.5">
        <p className="text-sm font-medium text-fg">{title}</p>
        {description && <p className="text-xs text-fg-secondary max-w-80 text-center">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 mt-1">{actions}</div>}
    </div>
  );
}
